module.exports = __webpack_public_path__ + "media/images/logo.rdmapps-09ac705f.png";